<template>
  <div class="">
    <div class="bg-primary-500 text-white p-4">
      <vk-modal-close outside @click="modalClose()"></vk-modal-close>
      <h2 class="text-white p-0 m-0">Kullanıcı Yetkileri, {{ user_group }}</h2>
    </div>
    <div class="w-full p-4">
      <div>
        Bu yetkiye sahip kullanıcı sayısı :
        <a :href="'/admin/users?user_group_id=' + user_group">{{
          userCount
        }}</a>
      </div>
      <div class="flex-inline items-center text-center relative">
        <VDropdown>
          <button class="global-button-xs">Başka grupdaki yetkileri çek</button>
          <template class="relative" #popper>
            <form
              class="text-xs relative p-2 flex items-center justify-between space-x-2"
              @submit.prevent="getCloneData(userGroupCloneId)"
            >
              <select v-model="userGroupCloneId" class="uk-select">
                <option
                  v-for="usrg in $root.cache.getOptions[26]"
                  :value="usrg.value"
                  :key="usrg.value"
                  >{{ usrg.label }}
                </option>
              </select>
              <SaveButton title="Yetkileri Getir" />
            </form>
          </template>
        </VDropdown>
      </div>
      <template v-if="tables.length > 0">
        <div class="text-xs">
          <form method="post" action="javascript:void(0)">
            <table class="uk-table uk-table-middle uk-table-divider">
              <thead>
                <tr>
                  <th>İsim</th>
                  <th :key="type.key" v-for="type in types">{{ type.name }}</th>
                  <th>Extra Sql</th>
                  <th></th>
                </tr>
                <tr>
                  <th></th>
                  <th :key="type.key" v-for="type in types">
                    <input
                      class="uk-checkbox"
                      @click="selectRootCheckbox(type.key)"
                      type="checkbox"
                    />
                  </th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <template v-for="table in tables">
                  <tr class="">
                    <th>
                      <h4>{{ table.name }}</h4>
                      <inline-edit
                        :fieldValue="table.name"
                        table="permissions"
                        fieldName="name"
                        keyName="id"
                        type="update"
                        @after="getData()"
                        :keyValue="table.id"
                      />
                    </th>
                    <td v-for="type in types">
                      <input
                        class="uk-checkbox"
                        v-model="rootCheckboxs"
                        :value="table.id + '|' + type.key"
                        type="checkbox"
                      />
                    </td>
                    <td class="w-1/2">
                      <input
                        type="text"
                        class="uk-input"
                        v-model="extraSql[table.id]"
                      />
                    </td>
                    <td class="">
                      <multiselect
                        class="text-xs w-60"
                        v-model="modules[table.id]"
                        :options="
                          filterModuleLabels(
                            $root.cache.getOptions[130],
                            table.table
                          )
                        "
                        :multiple="true"
                        :close-on-select="false"
                        :clear-on-select="false"
                        :preserve-search="true"
                        label="label"
                        track-by="label"
                      ></multiselect>
                    </td>

                    <td>
                      <template v-if="detailId == table.table">
                        <button class="primary-button" @click="detailId = null">
                          Kapat
                          <vk-icon icon="chevron-up"></vk-icon>
                        </button>
                      </template>
                      <button
                        class="global-button"
                        v-else
                        type="button"
                        @click="getFields(table.table)"
                      >
                        Alanlar
                        <vk-icon icon="chevron-down"></vk-icon>
                      </button>
                    </td>
                  </tr>

                  <tr class="sub-table" v-if="detailId == table.table">
                    <td colspan="9">
                      <div class="items">
                        <div class="flex w-full items-center">
                          <label class="label-title flex items-center">
                            <input
                              type="checkbox"
                              :class="'uk-checkbox all_' + table.id + '_list'"
                              :value="'uk-checkbox all_' + table.id + '_list'"
                              @click="
                                selectAllCheckbox(table.id, 'list', table.table)
                              "
                            />
                            Listeleyebileceği Alanlar
                          </label>

                          <small
                            >Listeleme sayfasında sadece seçili olanları
                            listeleyebilir</small
                          >
                        </div>
                        <div class="dflex">
                          <label v-for="field in fields[table.table]">
                            <input
                              class="uk-checkbox"
                              type="checkbox"
                              v-model="checkboxs"
                              :value="'list|' + table.id + '|' + field"
                            />
                            {{ field }}
                          </label>
                          <div class="fix"></div>
                        </div>
                      </div>
                      <div class="items">
                        <label class="label-title">
                          <input
                            class="uk-checkbox"
                            type="checkbox"
                            :class="'uk-checkbox all_' + table.id + '_read'"
                            :value="'uk-checkbox all_' + table.id + '_read'"
                            @click="
                              selectAllCheckbox(table.id, 'read', table.table)
                            "
                          />
                          Okuyabileceği alanlar
                        </label>
                        <small>
                          Detay sayfasında sadece okuyabileceği alanlar
                        </small>
                        <div class="fix"></div>
                        <div class="dflex">
                          <label v-for="field in fields[table.table]">
                            <input
                              class="uk-checkbox"
                              type="checkbox"
                              v-model="checkboxs"
                              :value="'read|' + table.id + '|' + field"
                            />
                            {{ field }}
                          </label>
                          <div class="fix"></div>
                        </div>
                      </div>

                      <div class="items">
                        <label class="label-title">
                          <input
                            type="checkbox"
                            :class="'uk-checkbox all_' + table.id + '_write'"
                            :value="'uk-checkbox all_' + table.id + '_write'"
                            @click="
                              selectAllCheckbox(table.id, 'write', table.table)
                            "
                          />
                          Yazma izni
                        </label>

                        <small
                          >Bu alanları seçerek yazma izni yani değiştirme izni
                          verebilirsiniz.</small
                        >
                        <div class="fix"></div>
                        <div class="dflex">
                          <label v-for="field in fields[table.table]">
                            <input
                              class="uk-checkbox"
                              type="checkbox"
                              v-model="checkboxs"
                              :value="'write|' + table.id + '|' + field"
                            />
                            {{ field }}
                          </label>
                          <div class="fix"></div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>

            <button type="submit" @click="saveForm()" class="green-button">
              Kaydet
            </button>
          </form>
        </div>
      </template>
      <template v-else>Sadece Root</template>
    </div>
  </div>
</template>

<script>
import multiselect from "vue-multiselect";
import InlineEdit from "../components/Ui/InlineEdit";
import InlineAdd from "../components/Ui/InlineAdd";
import httpService from "../services/http";
import EventBus from "../components/Ui/EventBus";
import SaveButton from "../components/Ui/SaveButton.vue";
export default {
  props: ["user_group"],
  data() {
    return {
      checkboxs: [],
      userCount: 0,
      extraSql: [],
      modules: [],
      userGroupCloneId: null,
      rootCheckboxs: [],
      tables: [],
      fields: [],
      types: [
        { key: "show", name: "Show" },
        { key: "delete", name: "Delete" },
        { key: "update", name: "Update" },
        { key: "excel_import", name: "Excel Import" },
        { key: "excel_export", name: "Excel Export" },
      ],
      detailId: null,
    };
  },
  components: {
    multiselect,
    "inline-edit": InlineEdit,
    "inline-add": InlineAdd,
    SaveButton,
  },
  methods: {
    filterModuleLabels(data, table) {
      return data.filter((item) => item.table === table);
    },
    userGroupSet() {
      this.getData();
    },
    selectRootCheckbox(key) {
      this.tables.forEach((item) => {
        this.rootCheckboxs.push(item.id + "|" + key);
      });
    },
    modalClose() {
      EventBus.$emit("modalClose", "true");
    },
    saveForm() {
      httpService
        .permissionSave({
          extra_sql: this.extraSql,
          modules: this.modules,
          user_group_id: this.user_group,
          root: this.rootCheckboxs,
          child: this.checkboxs,
        })
        .then((resp) => {
          this.$root.successMessage("İşlem başarıyla kaydedildi");
          this.modalClose();
        })
        .catch(() => {
          this.$root.errorMessage(
            "İşlem başarısız, yaptığınız işlemi tekrar kontrol ediniz"
          );
        });
    },
    selectAllCheckbox(id, type, table) {
      let isChecked = document.querySelector(".all_" + id + "_" + type).checked;
      if (isChecked) {
        Object.keys(this.fields[table]).forEach((item) => {
          if (this.checkboxs.indexOf(type + "|" + id + "|" + item) >= 0) {
          } else {
            this.checkboxs.push(type + "|" + id + "|" + item);
          }
        });
      } else {
        Object.keys(this.fields[table]).forEach((item) => {
          if (this.checkboxs.indexOf(type + "|" + id + "|" + item) == -1) {
          } else {
            this.checkboxs.splice(
              this.checkboxs.indexOf(type + "|" + id + "|" + item),
              1
            );
          }
        });
      }
    },
    getFields(table) {
      if (this.fields[table]) {
        this.detailId = table;
        this.fields[table];
      } else {
        this.$axios
          .post(this.$root.config.endpoint + "/table/" + table)
          .then((response) => {
            this.fields[table] = response.data.all_fields;
            this.detailId = table;
          });
      }
    },
    getCloneData(user_group) {
      this.rootCheckboxs = [];
      this.extraSql = [];
      this.modules = [];
      this.checkboxs = [];
      this.$axios
        .get(this.$root.config.endpoint + "/permissionsAdmin")
        .then((response) => {
          this.tables = response.data.tables;
        });
      this.$axios
        .get(this.$root.config.endpoint + "/permissions/" + user_group)
        .then((response) => {
          response.data.tables.map((item) => {
            if (item.show == 1) {
              this.rootCheckboxs.push(item.id + "|show");
            }
            if (item.delete == 1) {
              this.rootCheckboxs.push(item.id + "|delete");
            }
            if (item.excel_export == 1) {
              this.rootCheckboxs.push(item.id + "|excel_export");
            }
            if (item.excel_import == 1) {
              this.rootCheckboxs.push(item.id + "|excel_import");
            }
            if (item.update == 1) {
              this.rootCheckboxs.push(item.id + "|update");
            }
            if (item.extra_sql !== null) {
              this.extraSql[item.id] = item.extra_sql;
            }
            if (item.modules !== null) {
              this.modules[item.id] = item.modules
                .split(",")
                .map((item) => ({ label: item, value: item }));
            }
            let child_read_fields = item.read_fields.split(",");
            child_read_fields.map((e) => {
              this.checkboxs.push("read|" + item.id + "|" + e);
            });

            let child_write_fields = item.write_fields.split(",");
            child_write_fields.map((e) => {
              this.checkboxs.push("write|" + item.id + "|" + e);
            });
            let child_list_fields = item.list_fields.split(",");
            child_list_fields.map((e) => {
              this.checkboxs.push("list|" + item.id + "|" + e);
            });
          });
        });
    },
    getData() {
      this.rootCheckboxs = [];
      this.extraSql = [];
      this.modules = [];
      this.checkboxs = [];
      this.$axios
        .get(this.$root.config.endpoint + "/permissionsAdmin")
        .then((response) => {
          this.tables = response.data.tables;
        });
      this.$axios
        .get(this.$root.config.endpoint + "/permissions/" + this.user_group)
        .then((response) => {
          this.userCount = response.data.users.say;
          response.data.tables.map((item) => {
            if (item.show == 1) {
              this.rootCheckboxs.push(item.id + "|show");
            }
            if (item.delete == 1) {
              this.rootCheckboxs.push(item.id + "|delete");
            }
            if (item.excel_export == 1) {
              this.rootCheckboxs.push(item.id + "|excel_export");
            }
            if (item.excel_import == 1) {
              this.rootCheckboxs.push(item.id + "|excel_import");
            }
            if (item.update == 1) {
              this.rootCheckboxs.push(item.id + "|update");
            }
            if (item.extra_sql !== null) {
              this.extraSql[item.id] = item.extra_sql;
            }
            if (item.modules !== null) {
              this.modules[item.id] = item.modules
                .split(",")
                .map((item) => ({ label: item, value: item }));
            }
            let child_read_fields = item.read_fields.split(",");
            child_read_fields.map((e) => {
              this.checkboxs.push("read|" + item.id + "|" + e);
            });

            let child_write_fields = item.write_fields.split(",");
            child_write_fields.map((e) => {
              this.checkboxs.push("write|" + item.id + "|" + e);
            });
            let child_list_fields = item.list_fields.split(",");
            child_list_fields.map((e) => {
              this.checkboxs.push("list|" + item.id + "|" + e);
            });
          });
        });
    },
  },
  created() {
    this.getData();
  },
};
</script>

<style scoped>
.sub-table {
  border: 1px solid #eee;
}

.sub-table td {
  padding: 5px !important;
}

.sub-table h4 {
  font-size: 14px;
  padding: 0px;
  margin: 0px;
}

.sub-table .items .dflex {
  display: block;
}

.sub-table .items label {
  width: 240px;
  float: left;
}

.sub-table .items {
  background: #fff;
  padding: 10px;
  margin-bottom: 5px;
}

.sub-table label {
  font-size: 12px;
  color: #555;
}

.fix {
  clear: both;
}

.btn-flex {
  display: flex !important;
  align-items: center;
  align-content: center;
}

.label-title {
  font-weight: 500;
  font-size: 17px !important;
  color: #222 !important;
  margin-bottom: 10px;
  display: block;
}
</style>
